import './new-vehicle.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormVehicle from "../form-vehicle/form-vehicle";
import { useNewVehicle } from './new-vehicle.hook';

export function NewVehicle() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewVehicle();

  return (
    <div id="NewVehicle" className="vehicle">
      <HeaderContent
        title={<h1>New Vehicle</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormVehicle />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewVehicle;